import { render, staticRenderFns } from "./BodyDescription.vue?vue&type=template&id=00cce29f&scoped=true"
import script from "./BodyDescription.vue?vue&type=script&lang=js"
export * from "./BodyDescription.vue?vue&type=script&lang=js"
import style0 from "./BodyDescription.vue?vue&type=style&index=0&id=00cce29f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cce29f",
  null
  
)

export default component.exports